module.exports = __webpack_public_path__ + "img/roullet_ku.9b4de861.png";